var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1798_40807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 4.16797H14.5834V17.0858H1.6665V4.16797Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1798_40807)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70576 5.41909C5.33993 5.41909 5.10409 5.41909 5.06326 5.42076C4.44826 5.44659 3.88076 5.70742 3.47159 6.15409C3.08993 6.57159 2.89326 7.10492 2.91909 7.65826C2.91909 10.0691 2.91993 13.6874 2.92576 13.8858C3.02076 15.0399 4.10243 15.9224 5.34076 15.8274C7.63243 15.8308 11.0274 15.8383 11.1866 15.8324C11.7991 15.8074 12.3674 15.5474 12.7766 15.1016C13.1591 14.6858 13.3558 14.1524 13.3316 13.6016C13.3308 13.5924 13.3308 13.5833 13.3308 13.5741C13.3316 11.1908 13.3316 7.57492 13.3258 7.38076C13.2316 6.22076 12.1449 5.32742 10.8999 5.42492C9.17826 5.42242 6.82909 5.41909 5.70576 5.41909ZM5.12159 17.0858C3.35993 17.0866 1.82326 15.7366 1.67826 13.9658C1.67576 13.9316 1.66743 13.8274 1.66993 7.68659C1.62993 6.82742 1.94159 5.97409 2.54993 5.30992C3.18493 4.61659 4.06076 4.21242 5.01659 4.17159C5.13243 4.16326 9.13909 4.17326 10.8549 4.17659C12.7299 4.04492 14.4224 5.43659 14.5733 7.30409C14.5799 7.39492 14.5824 9.49909 14.5808 13.5616C14.6158 14.4416 14.3024 15.2891 13.6974 15.9474C13.0616 16.6399 12.1849 17.0424 11.2299 17.0816C11.1133 17.0899 7.10493 17.0791 5.38659 17.0758C5.29826 17.0824 5.20993 17.0858 5.12159 17.0858Z",
    fill: "url(#paint0_linear_1798_40807)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3484 15.2898C16.9726 15.2898 16.6017 15.1606 16.2959 14.9098L13.5617 12.6631C13.2951 12.444 13.2567 12.0498 13.4759 11.7831C13.6942 11.5173 14.0884 11.4773 14.3551 11.6973L17.0884 13.944C17.2726 14.094 17.4576 14.0323 17.5292 13.9973C17.6009 13.964 17.7667 13.8598 17.7667 13.6231L17.7767 7.49896C17.7776 7.26229 17.6109 7.15812 17.5392 7.12396C17.4684 7.09062 17.2809 7.02812 17.0984 7.17812L14.3542 9.42396C14.0859 9.64312 13.6934 9.60396 13.4751 9.33562C13.2559 9.06896 13.2959 8.67562 13.5626 8.45729L16.3067 6.21062C16.8101 5.79812 17.4876 5.71729 18.0751 5.99479C18.6626 6.27396 19.0276 6.85062 19.0267 7.50062L19.0167 13.6248C19.0159 14.2748 18.6501 14.8515 18.0634 15.1281C17.8334 15.2373 17.5901 15.2898 17.3484 15.2898Z",
    fill: "url(#paint1_linear_1798_40807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40807",
    x1: 8.12495,
    y1: 4.16797,
    x2: 8.12495,
    y2: 17.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40807",
    x1: 16.1801,
    y1: 5.83203,
    x2: 16.1801,
    y2: 15.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting-icon.0cbbcd3e2684a7aac3730bd784af991f.svg";
export { ForwardRef as ReactComponent };